import {SurgeIcon} from '@logistics-frontend/blocks'
import clsx from 'clsx'
import React from 'react'

import * as classes from './Surge.classes'
import {Props} from './types'
import {beautifySurgeRatio, getSurgeVariant} from './utils'

export const Surge = React.memo<Props>(function SurgeBase({ratio: ratioProp, className, showBaseSurge}) {
  const ratio = typeof ratioProp === 'string' ? parseFloat(ratioProp) : ratioProp

  if (ratio === 1 && !showBaseSurge) {
    return null
  }

  return (
    <div className={clsx(classes.icon, classes.variant[getSurgeVariant(ratio)], className)}>
      <SurgeIcon />
      <span>{beautifySurgeRatio(ratio)}</span>
    </div>
  )
})
